import React, { useEffect, useMemo } from 'react'
// import { Link } from "react-router-dom";
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setRecord, setTableData } from './store/dataSlice'
// import { HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";
// import Tooltip from "components/Ui/Tooltip";
import {
    // ConfirmationModal,
    Table,
} from 'components/Ui'
import { getApiData } from 'services/StockHoldingsService'
// import { Success } from "utils/alerts";
// import useAuth from "utils/hooks/useAuth";
// import { carrier, carrierService, orderType, siteLabel, status } from 'components/helper'
injectReducer('stockHoldings', reducer)

export default function StockHoldings() {
    const dispatch = useDispatch()
    // const { checkPermission } = useAuth();
    const { data, tableData, loading } = useSelector(state => state.stockHoldings.data)
    const { company, customer } = useSelector(state => state.filterData)
    const { companyData, customersData } = useSelector(state => state.listData)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        company,
        customer,
    ])

    const fetchData = () =>
        dispatch(
            getData({
                ...tableData,
                company: company ? companyData?.find(item => item?.id?.toString() === company?.toString())?.code : '',
                customer: customer
                    ? customersData?.find(item => item?.id?.toString() === customer?.toString())?.customer_code
                    : '',
            })
        )

    const filterData = () => {
        const sort = tableData?.sort || []
        let filtered = data?.filter(item => {
            // if (customer) {
            //     return item?.customer?.toString() === customer
            // }
            return true
        })

        if (sort?.length > 0) {
            sort?.forEach(({ column, dir }) => {
                filtered = filtered?.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }
        return filtered || []
    }

    //   const handleDelete = (id) => {
    //     deleteApiRecord(id)
    //       .then(() => {
    //         Success("Deleted Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    //   const handleStatus = (id, data) => {
    //     delete data.image;
    //     updateApiRecord(id, data)
    //       .then(() => {
    //         Success("Status Updated Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    const columns = useMemo(
        () => [
            {
                field: 'whse',
                header: 'Whse',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'organization',
                header: 'Company',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'customer',
                header: 'Customer',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Product',
                header: 'Product',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'description',
                header: 'Description',
                className: 'min-w-[250px]',
                orderable: true,
            },
            {
                field: 'total_qty',
                header: 'Total Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total_Available',
                header: 'Total Available Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total_Allocated',
                header: 'Total Allocated Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total_Held',
                header: 'Total Hold Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total_Locations',
                header: 'Total Locations',
                className: 'min-w-[150px]',
                orderable: true,
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Stock Holdings</h2>
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <Table
                    loading={loading}
                    filter={false}
                    // siteFilter={true}
                    // statusFilter={true}
                    // carrierFilter={true}
                    // clientFilter={true}
                    download={true}
                    datas={filterData()}
                    columns={columns}
                    pagingData={tableData}
                    view={'/meson-wms/stock-holdings/'}
                    onChange={e => dispatch(setTableData(e))}
                    csvDownloadApi={getApiData}
                    setRecord={setRecord}
                    viewId={'Product'}
                />
            </div>
        </>
    )
}
